module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_250000_500000.3d2613ec.png";